
import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ToolsDashboard from "./pages/ToolsDashboard";
import NewCase from "./pages/NewCase";
import Dashboard from "./pages/Dashboard";
import CaseDetail from "./pages/CaseDetail";
import SpamhausTool from "./pages/SpamhausTool";
import SpamhausHistory from "./pages/SpamhausHistory";
import GoogleMalwareReporter from "./pages/GoogleMalwareReporter";
import GoogleMalwareHistory from "./pages/GoogleMalwareHistory";
import MalwareBazaarTool from "./pages/MalwareBazaarTool";
import MalwareBazaarHistory from "./pages/MalwareBazaarHistory";
import Login from "./pages/Login";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === "true";
  });

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route 
          path="/" 
          element={
            isAuthenticated ? (
              <ToolsDashboard onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        <Route
          path="/tools"
          element={
            isAuthenticated ? (
              <ToolsDashboard onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/new-case"
          element={
            isAuthenticated ? (
              <NewCase onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <Dashboard onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/case/:caseNumber"
          element={
            isAuthenticated ? (
              <CaseDetail onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/spamhaus"
          element={
            isAuthenticated ? (
              <SpamhausTool onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/spamhaus/history"
          element={
            isAuthenticated ? (
              <SpamhausHistory onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/google-malware"
          element={
            isAuthenticated ? (
              <GoogleMalwareReporter onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/google-malware/history"
          element={
            isAuthenticated ? (
              <GoogleMalwareHistory onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/malware-bazaar"
          element={
            isAuthenticated ? (
              <MalwareBazaarTool onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/malware-bazaar-history"
          element={
            isAuthenticated ? (
              <MalwareBazaarHistory onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
